// config.js
import axios from 'axios';
import axiosRetry from 'axios-retry';
import showToast from './utils/toast';
import rateLimit from 'axios-rate-limit';

export const API = process.env.REACT_APP_API_URL;

rateLimit(axios, {
  maxRequests: 5,
  perMilliseconds: 1000,
  maxRPS: 5,
});

// Retry on 429 (Too Many Requests)
axiosRetry(axios, {
  retries: 3,
  retryCondition: (error) => error.response?.status === 429,
  retryDelay: (retryCount, error) => {
    const retryAfter = error.response?.headers['retry-after'];
    if (retryAfter) {
      return parseInt(retryAfter) * 1000;
    }
    return axiosRetry.exponentialDelay(retryCount);
  },
});

// Set to keep track of warned requests (to prevent spamming warnings)
const warnedRequests = new Set();

// Add an interceptor to warn if 429 happens
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 429) {
      const requestId = error.config?.url + error.config?.method;

      if (!warnedRequests.has(requestId)) {
        warnedRequests.add(requestId);

        // ✅ Send your warning here
        showToast(' Retrying...');
      }
    }

    return Promise.reject(error); // Pass error to axios-retry if needed
  }
);

